$(function() {

    // Initailise vue cart script

    var app = new Vue({
        delimiters: ['${','}'],
        el: '#vue-cart',
        data: {
            cart: window.cart,
            freeShipping: window.cartFreeShipping || false,
            over18: false,

        },
        created: function() {
            this.setupCartEventHandler();
        },
        computed: {
            formattedPrice: function() {
                return (this.cart.total_price / 100).toFixed(2);
            },
            hasFreeShipping: function() {
                if(this.freeShipping) {
                    return this.freeShippingDifference == 0;
                }
                return false;
            },
            freeShippingDifference: function() {
                if(this.freeShipping) {
                    return Math.max(0, this.freeShipping - this.cart.total_price);
                }
                return false;
            },
            freeShippingPercentage: function() {
                if(this.freeShipping) {
                    return Math.min(100, (100 / this.freeShipping * this.cart.total_price));
                }
                return false;
            },
            formattedFreeShippingDifference: function() {
                return (this.freeShippingDifference / 100).toFixed(2);
            },
            hasSubscriptionItems: function() {
              for(var i in this.cart.items) {
                if(this.isSubscription(this.cart.items[i])) {
                   return true;
                }
              }
              return false;
            },
            requiresAgeConsent: function() {

                for(var i in this.cart.items) {
                    if(this.containsTag(i, 'age-restriction')) {
                       return true;
                    }
                }
                return false;

            }
        },

        methods: {
            setupCartEventHandler: function () {
                var $this = this;
                $(document).on('cart.requestComplete', function(event, cart) {
                    $this.cart = cart;

                    $('.j-toggle-cart .counter').text(cart.item_count);

                });
            },

            increment: function(index){

                var currentQuantity = this.cart.items[index].quantity;
                CartJS.updateItem(index + 1, currentQuantity + 1);
                window.navigator.vibrate(100);
                
            },

            decrement: function(index){

                var currentQuantity = this.cart.items[index].quantity;
                CartJS.updateItem(index + 1, currentQuantity - 1);
                window.navigator.vibrate(100);

            },

            remove: function(index){

                var currentQuantity = this.cart.items[index].quantity;
                CartJS.updateItem(index + 1, 0);
                window.navigator.vibrate(100);
                
            },

            isSubscription: function(line_item){
                if (line_item != null && line_item.properties != null && typeof line_item.properties.frequency_num != 'undefined') {
                    return true;
                } else {
                    return false;
                }
            },
            proceedToCheckout: function(event) {
              if(this.hasSubscriptionItems) {
                try {
    				BoldSubscriptions.checkout.goToCheckout(event);
                }
                catch(error) {
                 	// do nothing. 
                }
              } else {
                //window.location = '/checkout';
                $('#checkout-action').trigger('click');
              }
            },
            containsTag: function(index, tag){
              try {
                //console.log(index, tag, typeof this.cart.items[index].properties._tags);
                if(typeof this.cart.items[index].properties._tags == 'string') {
                  var tags = this.cart.items[index].properties._tags;
                  if( tags.indexOf(tag) != -1 ) {
                    return true;
                  }
                }
              }
              catch(error) {
                // fail silently
              }
              return false;
            }
        },

        filters: {
            weightFormat: function (value) {
                if (!value) return ''
                value = value.split(':').sort().join().replace(/,/g, ' ');
                value = value.toString()
                return value.charAt(0).toUpperCase() + value.slice(1)
            }
        }
    })

});